import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

export default function LighthouseLoginModal({ open, onProceed, onOpenChange }) {
  const [dontShowAgain, setDontShowAgain] = React.useState(false);

  const handleProceed = () => {
    if (dontShowAgain) {
      localStorage.setItem('dontShowLighthousePopup', 'true');
    }
    onProceed(dontShowAgain);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="lighthouse-lighthouseloginmodal-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Launch Lighthouse</DialogTitle>
          <DialogDescription>
            Are you already logged in to Lighthouse on another tab in your browser?
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex items-center space-x-2 py-4">
          <Checkbox 
            id="dont-show" 
            checked={dontShowAgain}
            onCheckedChange={setDontShowAgain}
          />
          <Label htmlFor="dont-show" className="cursor-pointer">
            Don't show this again
          </Label>
        </div>

        <DialogFooter>
          <Button data-testid="lighthouse-proceed-btn" onClick={handleProceed} className="w-full">
            Proceed
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}